// extracted by mini-css-extract-plugin
export var dividerLine = "_73-3";
export var itemImage = "_73-9";
export var lightDivider = "_73-4";
export var modalContent = "_73-5";
export var modalContentCompact = "_73-6";
export var productCard = "_73-a";
export var productImage = "_73-b";
export var productImageCompact = "_73-7";
export var productImagePlaceholder = "_73-c";
export var productImagePlaceholderCompact = "_73-8";
export var progressBarBackground = "_73-1";
export var progressBarContainer = "_73-0";
export var progressBarFill = "_73-2";